import { ITerritory } from "containers/territories/model";
import { IListSchema } from "model/entities/List";

export interface ITerritoryState {
  isFetchingOneTerritoryItem: boolean;
  isUpdatingTerritoryItem: boolean;
  isArchivingTerritoryItem: boolean;
  isRestoringTerritoryItem: boolean;
  isCreatingTerritoryItem: boolean;

  isFetchingTerritoriesItems: boolean;
  isUpdatingTerritoriesItems: boolean;
  isDeletingTerritoriesItems: boolean;
  isCreatingTerritoriesItems: boolean;
  isAssigningTerritoriesItems: boolean;
  isUnassigningTerritoriesItems: boolean;

  isFetchingTerritoryList: boolean;
  isFetchingTerritorySchema: boolean;
  isUpdatingTerritorySchema: boolean;

  territoriesSchema: IListSchema[];
  territories: ITerritory[];
  item_count?: number;
  hasMoreTerritories?: boolean;
  errors: any[];
  filterQuery?: any;
}

export const territoryInitialState: ITerritoryState = {
  isFetchingTerritoriesItems: false,
  isFetchingOneTerritoryItem: false,
  isUpdatingTerritoriesItems: false,
  isDeletingTerritoriesItems: false,
  isCreatingTerritoriesItems: false,
  isAssigningTerritoriesItems: false,
  isUnassigningTerritoriesItems: false,

  isUpdatingTerritoryItem: false,
  isArchivingTerritoryItem: false,
  isRestoringTerritoryItem: false,
  isCreatingTerritoryItem: false,
  isFetchingTerritorySchema: false,
  isUpdatingTerritorySchema: false,

  isFetchingTerritoryList: false,

  territoriesSchema: [],
  territories: [],
  hasMoreTerritories: false,
  errors: [],

  filterQuery: {},
};
